import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/kit";
import { API, api, errMsg } from "@/lib/api";

const Box = ({ src, label, testId }) => (
  <div className="space-y-1">
    <div className="text-xs uppercase tracking-wider text-[#7B929C]">{label}</div>
    <div className="h-40 rounded-lg border border-[#D4E6EC] bg-[repeating-conic-gradient(#F1F5F9_0_25%,#fff_0_50%)] bg-[length:16px_16px] flex items-center justify-center p-3">
      <img src={src} alt={label} className="max-h-full max-w-full object-contain" data-testid={testId} />
    </div>
  </div>
);

export const LogoEnhance = ({ k, label, onDone }) => {
  const [busy, setBusy] = useState(false);
  const [ver, setVer] = useState(0);
  const run = async () => {
    setBusy(true);
    try {
      await api.post(`/brand/logo/${k}/enhance`);
      setVer(Date.now());
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  const finish = async (action) => {
    try {
      await api.post(`/brand/logo/${k}/enhanced/${action}`);
      toast.success(action === "apply" ? "Nuovo logo in uso su tutti i documenti" : "Tenuto il logo originale");
      setVer(0);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="rounded-full" disabled={busy} onClick={run} data-testid={`logo-${k}-enhance`}>
        {busy ? <Loader2 size={13} className="mr-1 animate-spin" /> : <Sparkles size={13} className="mr-1" />} {busy ? "Sto migliorando…" : "Migliora con IA"}
      </Button>
      <Modal open={!!ver} onOpenChange={(o) => !o && finish("discard")} title={`Logo migliorato • ${label}`} testId={`logo-${k}-enhance-modal`}>
        <p className="text-sm text-[#47606B]">Controlla bene scritte e simboli: l'IA a volte cambia qualche lettera. Se va bene, il nuovo logo sostituisce l'originale ovunque.</p>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          <Box src={`${API}/public/logo/${k}?v=${ver}`} label="Originale" testId={`logo-${k}-original`} />
          <Box src={`${API}/brand/logo/${k}/enhanced?v=${ver}`} label="Migliorato con IA" testId={`logo-${k}-enhanced`} />
        </div>
        <div className="flex flex-wrap justify-end gap-2 mt-4">
          <Button variant="ghost" className="rounded-full" onClick={() => finish("discard")} data-testid={`logo-${k}-discard`}>Tieni l'originale</Button>
          <Button variant="outline" className="rounded-full" onClick={run} disabled={busy} data-testid={`logo-${k}-retry`}>{busy && <Loader2 size={13} className="mr-1 animate-spin" />} Riprova</Button>
          <Button className="rounded-full" onClick={() => finish("apply")} disabled={busy} data-testid={`logo-${k}-apply`}>Usa il nuovo logo</Button>
        </div>
      </Modal>
    </>
  );
};
